import useBIMClass from "./useBIMClass";
import * as UIKit from "../../ui-kit";


export default function BIMClass(props) {
    const { children, id, ...restProps } = props;

    const bimClassQuery = useBIMClass(id);

    if (!id) return undefined;

    if (bimClassQuery.loading) return <UIKit.CardSkeleton />;
    if (bimClassQuery.error) return undefined;

    return (
        <UIKit.Card { ...restProps }>
            <UIKit.LetterBackdrop>BC</UIKit.LetterBackdrop>
            <UIKit.CardFace2>
                <span className="fluid-accent">{ bimClassQuery.data.bimClass.data.name[0].text }</span>
                <span>{ bimClassQuery.data.bimClass.id }</span>
            </UIKit.CardFace2>
            { children }
        </UIKit.Card>
    );
}
